module.exports = __webpack_public_path__ + "img/analytic120speed.b56459ab.svg";